import * as Blockly from 'blockly/core';

export function registerBoolPreset(workspace: Blockly.WorkspaceSvg): void {
    const varMap = workspace.getVariableMap();
    if (!varMap.getVariable('flag', 'bool')) {
        varMap.createVariable('flag', 'bool');
    }
}
